// extracted by mini-css-extract-plugin
module.exports = {"imatge":"historia_imatge__zYu5r","textDesplegable":"historia_textDesplegable__0H6_n","contingutDesplegable":"historia_contingutDesplegable__SojUJ"};